<template>
  <div v-outside-click="hideContextMenu" style="position: relative">
    <sub-context :data="data" :depth="0" @hide-subcontext-menu="hideContextMenu" />
  </div>
</template>
<script>
import { HotkeyScopes } from "../../../../utils/constants";
import { icons } from "../../../../utils/icons";
import SubContext from "../../../redZone/content/SubContext.vue";
import DesignerMixin from "../../DesignerMixin";
import { getShortcutText } from "../../../../utils/util";
export default {
  components: { SubContext },
  mixins: [DesignerMixin],
  data() {
    return {
      data: [
        {
          id: 1,
          icon: `${icons.Cut}`,
          title: this.$t("contextMenu.cut"),
          shortcut: getShortcutText("Ctrl+X"),
          func: this.cutText,
          hide: false,
          testId: "cut-cell-data",
        },
        {
          id: 2,
          icon: `${icons.Copy}`,
          title: this.$t("contextMenu.copy"),
          shortcut: getShortcutText("Ctrl+C"),
          func: this.copyText,
          hide: false,
          testId: "copy-cell-data",
        },
        {
          id: 3,
          icon: `${icons.Paste}`,
          title: this.$t("contextMenu.paste"),
          shortcut: getShortcutText("Ctrl+V"),
          func: this.pasteText,
          hide: false,
          testId: "paste-cell-data",
        },
      ],
    };
  },
  computed: {
    activeContextMenu() {
      return this.$store.state.activeContextMenu;
    },
  },
  mounted() {
    this.$store.dispatch("setScope", HotkeyScopes.SidebarContextMenu);
  },
  beforeUnmount() {
    this.$store.dispatch("setScope", HotkeyScopes.ProcessDesigner);
  },
  include() {
    return [document.querySelector(".contextmenu")];
  },
  methods: {
    hideContextMenu(event) {
      // if (event && !this.$el.contains(event.target) || !event.target.closest(".contextmenu")) {
      this.$store.dispatch("resetActiveContextMenu");
      this.$store.dispatch("setScope", HotkeyScopes.ProcessDesigner);
      // }
    },
    cutText() {
      this.$store.dispatch("cells/copyContent", { isCut: true });
      this.hideContextMenu();
    },
    copyText() {
      this.$store.dispatch("cells/copyContent", {});
      this.hideContextMenu();
    },
    pasteText() {
      this.$store.dispatch("cells/pasteContent");
      this.hideContextMenu();
    },
  },
};
</script>
